export default "__VITE_ASSET__012c7b73__"